import RouteError from '@/components/layout/Page/RouteError.vue';
import RouteLoading from '@/components/layout/Page/RouteLoading.vue';

const routes = [{
  path: 'monitor',
  name: 'monitors',
  component: () => import(/* webpackChunkName: "monitor-section" */ '@/components/pages/monitor/Monitors.vue'),
  meta: { title: 'Manage rules' },
},
{
  path: 'monitor/create',
  name: 'createMonitor',
  component: () => import(/* webpackChunkName: "monitor-section" */ '@/components/pages/monitor/MonitorBuilder.vue'),
  meta: { title: 'Create rule' },
},
{
  path: 'monitor/edit/:id',
  name: 'editMonitor',
  component: () => import(/* webpackChunkName: "monitor-section" */ '@/components/pages/monitor/MonitorUpdater.vue'),
  meta: { title: 'Edit rule' },
}];

export default routes.map((route) => ({
  ...route,
  loading: RouteLoading,
  error: RouteError,
  delay: 200, // Delay before showing the loading component
  timeout: 5000, // The error component will be displayed if a timeout is provided and exceeded
  meta: {
    ...route.meta,
    section: 'Monitor',
  },
}));
